import tvWatcherPic from "../assets/tvwatcher.PNG";
import ravenousPic from "../assets/ravenous.PNG";
import jammingPic from "../assets/Jamming.PNG";
import gifosPic from "../assets/gifos.PNG";
import delilahPic from "../assets/delilah.PNG";
import portfolioPic from "../assets/portfolio.PNG";

const tvWatcher = {
  img: tvWatcherPic,
  title: "TV Watcher",
  github: "https://github.com/luemigues/tvWatcher",
  website: "https://tv-watcher.netlify.app/",
};

const ravenous = {
  img: ravenousPic,
  title: "Ravenous",
  github: "https://github.com/luemigues/Ravenous",
  website: "https://luemigues-ravenous.netlify.app/",
};

const jamming = {
  img: jammingPic,
  title: "Jamming",
  github: "https://github.com/luemigues/jammingApp",
  website: "https://luemigues-jamming.netlify.app/",
};

const gifos = {
  img: gifosPic,
  title: "Gifos",
  github: "https://github.com/luemigues/gifOS",
  website: "https://luemigues-gifos.netlify.app/",
};

const delilah = {
  img: delilahPic,
  title: "Delilah Resto API Rest",
  github: "https://github.com/luemigues/delilah-resto",
  website: "https://documenter.getpostman.com/view/12198401/TW74k5fZ",
};

const portfolio = {
  img: portfolioPic,
  title: "Portfolio",
  github: "https://github.com/luemigues/portfolio",
};

const sites = [portfolio, tvWatcher, delilah, ravenous, jamming, gifos];

export default sites;
